var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ltv-analysis-table-cont"},[_c('t-enhanced-table',{ref:"table",attrs:{"row-key":"date","columns":_vm.columns,"data":_vm.data,"table-layout":"auto","stripe":"","tree":{ treeNodeColumnIndex: 0 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }